import { h } from 'preact';
import LottieAnimation from '../LottieAnimation';
import animationLoad from "../../../assets/animations/load.json";
import animationLoadDots from "../../../assets/animations/LoaderDots.json";


const LoadingIcon = ({size, height, width, loadDots = false}) => {
  return (
    <div style={{width: width || size, height: height || size}}>
        <LottieAnimation animationData={ loadDots ? animationLoadDots : animationLoad} />
    </div>
  );
};

export default LoadingIcon;


// WEBPACK FOOTER //
// ./components/elements/LoadingIcon/index.js